import { render, staticRenderFns } from "./ListenerAlbumLibrary.vue?vue&type=template&id=4597c3ba&scoped=true"
import script from "./ListenerAlbumLibrary.vue?vue&type=script&lang=js"
export * from "./ListenerAlbumLibrary.vue?vue&type=script&lang=js"
import style0 from "./ListenerAlbumLibrary.vue?vue&type=style&index=0&id=4597c3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4597c3ba",
  null
  
)

export default component.exports